import { Link, useLocation } from 'react-router-dom';

/**
 * Smoothly scrolls to a hash target with a 70px offset for the fixed nav.
 */
export function scrollToHash(hash) {
  const el = document.querySelector(hash);
  if (el) {
    window.scrollTo({ top: el.offsetTop - 70, behavior: 'smooth' });
  }
}

/**
 * HashLink
 *
 * Links to an in-page section (e.g. "#services") that lives on the landing
 * page. If already on the landing page ('/'), it smooth-scrolls in place.
 * From any other page it navigates to '/' with the hash, and the landing
 * page scrolls to the section on arrival (handled by Nav's hash effect).
 *
 * Props:
 *   hash:      the target hash, including '#' (e.g. "#faq")
 *   children:  link content
 *   className: optional class name
 */
function HashLink({ hash, children, className }) {
  const location = useLocation();

  function handleClick(e) {
    if (location.pathname === '/') {
      // Already on landing — smooth-scroll in place instead of re-navigating.
      e.preventDefault();
      scrollToHash(hash);
    }
    // Otherwise let the Link navigate to '/' + hash; the landing page scrolls
    // to the section on arrival.
  }

  return (
    <Link to={{ pathname: '/', hash }} className={className} onClick={handleClick}>
      {children}
    </Link>
  );
}

export default HashLink;
